import Cookies from "js-cookie";
const state = {
  loggedUser: "",
  waiting_users_error: false,
  userServices: [],
  userServicesError: "",
  usersUnverifiedPhotos: [],
  usersUnverifiedPhotosError: "",
  waiting_users: [],
  deleted_users: [],
  isDeleted: false,
  waiting_users_pagination: {
    on_page: 20,
    page_number: 1,
  },
  sers_error: false,
  users: [],
  users_pagination: {
    on_page: 20,
    page_number: 1,
  },
  change_employee_status: null,
  user_by_phone: {},
  user_by_id: {},
  selectedUser: null,
  selectedUserError: null,
  waitingUserCounter: null,
  numberOfUnreadMessages: null,
  userRole: Cookies.get("role"),
  usersWithCommissions: [],
  allAdmins: [],
  waitingUsersWithoutPayment: [],
  smsList: [],
  usersInSpecifiedArea: [],
  promotionalCodes: [],
  userPromotionalCodes: [],
  usersWhoTriedToLogIn: [],
  numberOfUsersWhoTriedToLogIn: null,
  userGroupsCounter: null,
  phoneNumbersToGroupMessage: [],
  partners: [],
  numberOfSentSmsesInCurrentMonth: 0,
  blank: "",
  mainAppUser: null,
};

const mutations = {
  SET_BLANK(state, blank) {
    state.blank = blank;
  },
  SET_PHONES_NUMBERS_TO_GROUP_MESSAGE(state, phones) {
    state.phoneNumbersToGroupMessage = phones;
  },
  SET_SELECTED_USER_ERROR(state, error) {
    state.selectedUserError = error;
  },
  SET_DELETED_USERS(state, deleted_users) {
    state.deleted_users = deleted_users;
  },
  SET_IS_DELETED(state, res) {
    state.isDeleted = res;
  },
  SET_PROFILES(state, users) {
    state.users = users.list;
  },
  SET_PROFILES_ERROR(state, error) {
    state.users_error = error;
  },
  SET_PROFILES_PAGINATION(state, res) {
    state.users_pagination = {
      on_page: res.on_page,
      page_number: res.page_number,
      total: res.total,
    };
  },
  SET_PROFILE_WITH_WAITING_STATUS(state, users) {
    state.waiting_users = users;
  },
  SET_PROFILE_WITH_WAITING_STATUS_ERROR(state, error) {
    state.waiting_users_error = error;
  },
  SET_PROFILE_WITH_WAITING_STATUS_PAGINATION(state, res) {
    state.waiting_users_pagination = {
      on_page: res.on_page,
      page_number: res.page_number,
    };
  },
  CHANGE_EMPLOYEE_STATUS(state, res) {
    state.change_employee_status = res;
    setTimeout(() => {
      state.change_employee_status = null;
    }, 5000);
  },
  SET_USER_BY_PHONE(state, res) {
    state.user_by_phone = res;
  },
  SET_USER_BY_ID(state, payload) {
    state.user_by_id = payload;
  },
  SET_USER_SERVICES(state, payload) {
    state.userServices = payload;
  },
  SET_USER_SERVICES_ERROR(state, payload) {
    state.userServicesError = payload;
  },
  SET_PROFILES_WITH_UNVERIFIED_PHOTOS(state, payload) {
    state.usersUnverifiedPhotos = payload;
  },
  SET_PROFILES_WITH_UNVERIFIED_PHOTOS_ERROR(state, payload) {
    state.usersUnverifiedPhotosError = payload;
  },
  SET_SELECTED_USER(state, payload) {
    state.selectedUser = payload;
  },
  SET_WAITING_USERS_COUNTER(state, payload) {
    state.waitingUserCounter = payload;
  },
  SET_NUMBER_OF_UNREAD_MESSAGES(state, payload) {
    state.numberOfUnreadMessages = payload;
  },
  SET_USER_ROLE(state, role) {
    state.userRole = role;
  },
  SET_USERS_WITH_COMMISSIONS(state, users) {
    state.usersWithCommissions = users;
  },
  SET_ADMINS(state, admins) {
    state.allAdmins = admins;
  },
  SET_WAITING_USERS_WITHOUT_PAYMENT(state, users) {
    state.waitingUsersWithoutPayment = users;
  },
  SET_SMS_LIST(state, list) {
    state.smsList = list;
  },
  SET_USERS_IN_SPECIFIED_AREA(state, users) {
    state.usersInSpecifiedArea = users;
  },
  SET_PROMOTIONAL_CODES(state, codes) {
    state.promotionalCodes = codes;
  },
  SET_USER_PROMOTIONAL_CODES(state, codes) {
    state.userPromotionalCodes = codes;
  },
  SET_PROFILES_WHO_TRIED_TO_LOGIN(state, users) {
    state.usersWhoTriedToLogIn = users;
  },
  SET_NUMBER_OF_USERS_WHO_TRIED_TO_LOGIN(state, number) {
    state.numberOfUsersWhoTriedToLogIn = number;
  },
  SET_USER_GROUPS_COUNTER(state, userGroupsCounter) {
    state.userGroupsCounter = userGroupsCounter;
  },
  SET_PARTNERS(state, partners) {
    state.partners = partners;
  },
  SET_LOGGED_USER(state, login) {
    state.loggedUser = login;
  },
  SET_SENT_SMSES_IN_CURRENT_MONTH(state, number) {
    state.numberOfSentSmsesInCurrentMonth = number;
  },
  SET_MAIN_APP_USER(state, user) {
    state.mainAppUser = user;
  },
};

const getters = {
  getLoggedUser: (state) => state.loggedUser,
  getSmsList: (state) => {
    return state.smsList;
  },
  getUsersWithUnverifiedPhotos: (state) => {
    return state.usersUnverifiedPhotos;
  },
  getUserServices: (state) => {
    return state.userServices;
  },
  getDeletedUsers: (state) => {
    return state.deleted_users;
  },
  getUsersWithoutPagination: (state) => {
    return state.users;
  },
  getUsers: (state) => {
    return {
      data: state.users,
      error: state.users_error,
      pagination: state.users_pagination,
    };
  },
  getWaitingUsers: (state) => {
    return {
      data: state.waiting_users,
      error: state.waiting_users_error,
      pagination: state.waiting_users_pagination,
    };
  },

  getWaitingUsersWithoutPayment: (state) => {
    return {
      data: state.waitingUsersWithoutPayment,
    };
  },
  getEmployeeStatus: (state) => {
    return state.change_employee_status;
  },
  getUserByPhone: (state) => {
    return { userByPhone: state.user_by_phone };
  },
  getUserById: (state) => {
    return state.user_by_id;
  },
  getSelectedUser: (state) => {
    return state.selectedUser;
  },
  getSelectedUserError: (state) => {
    return state.selectedUserError;
  },
  getWaitingUsersCounter: (state) => {
    return state.waitingUserCounter;
  },
  getNumberOfUnreadMessages: (state) => {
    return state.numberOfUnreadMessages;
  },
  getUserRole: (state) => {
    return state.userRole;
  },
  getUsersWithCommissions: (state) => {
    return state.usersWithCommissions;
  },
  getAllAdmins: (state) => {
    return state.allAdmins;
  },
  getUserInSpecifiedArea: (state) => {
    return state.usersInSpecifiedArea;
  },
  getAllPromotionalCodes: (state) => {
    return state.promotionalCodes;
  },
  getUserPromotionalCodes: (state) => {
    return state.userPromotionalCodes;
  },
  getUsersWhoTriedToLogIn: (state) => {
    return state.usersWhoTriedToLogIn;
  },
  getNumberOfUsersWhoTriedToLogIn: (state) => {
    return state.numberOfUsersWhoTriedToLogIn;
  },
  getUserGroupsCounter: (state) => {
    return state.userGroupsCounter;
  },
  getPartners: (state) => {
    return state.partners;
  },
  getPhoneNumbersToGroupMessages: (state) => state.phoneNumbersToGroupMessage,
  getNumberOfSentSmsesInCurrentMonth: (state) =>
    state.numberOfSentSmsesInCurrentMonth,
  getMainAppUser: (state) => state.mainAppUser,
};

export default {
  state,
  mutations,
  getters,
};
